<template>

    <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
    width="512.000000pt" height="512.000000pt" viewBox="0 0 512.000000 512.000000"
    preserveAspectRatio="xMidYMid meet">
        <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="currentColor" stroke="none">
            <path d="M1288 5099 c-23 -12 -46 -35 -58 -59 -20 -39 -20 -57 -20 -1185 l0
            -1145 -545 0 c-527 0 -547 -1 -585 -20 -26 -13 -47 -34 -60 -60 -20 -39 -20
            -56 -20 -1275 0 -1219 0 -1236 20 -1275 13 -26 34 -47 60 -60 39 -20 56 -20
            1275 -20 1219 0 1236 0 1275 20 26 13 47 34 60 60 19 38 20 58 20 585 l0 545
            1145 0 c1129 0 1146 0 1185 20 26 13 47 34 60 60 20 39 20 55 20 1875 0 1820
            0 1836 -20 1875 -13 26 -34 47 -60 60 -39 20 -54 20 -1877 20 -1810 -1 -1839
            -1 -1875 -21z m3532 -1934 l0 -1655 -1055 0 -1055 0 0 540 c0 522 -1 542 -20
            580 -13 26 -34 47 -60 60 -38 19 -58 20 -580 20 l-540 0 0 1055 0 1055 1655 0
            1655 0 0 -1655z m-3610 -1295 c0 -522 1 -542 20 -580 13 -26 34 -47 60 -60 38
            -19 58 -20 580 -20 l540 0 0 -455 0 -455 -1055 0 -1055 0 0 1055 0 1055 455 0
            455 0 0 -540z m1200 90 l0 -450 -450 0 -450 0 0 450 0 450 450 0 450 0 0 -450z"/>
            <path d="M3688 4489 c-43 -22 -78 -81 -78 -129 0 -50 35 -107 80 -130 33 -17
            59 -20 172 -20 l133 0 -477 -477 c-262 -263 -483 -492 -492 -510 -61 -122 75
            -258 197 -197 18 9 247 230 510 492 l477 477 0 -133 c0 -113 3 -139 20 -172
            23 -45 80 -80 130 -80 50 0 107 35 130 80 19 37 20 58 20 370 0 312 -1 333
            -20 370 -13 26 -34 47 -60 60 -37 19 -58 20 -372 20 -312 -1 -335 -2 -370 -21z"/>
        </g>
    </svg>

</template>